import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/authentication/api'
import helpers from '@/modules/message/helpers'
import { t } from '@/plugins/i18n.ts'
import router from '@/router'
import { ChangePasswordDto, PasswordResetDto, Token } from '@/types/index'
import { defineStore } from 'pinia'

interface PasswordReset {
  tokenError: boolean
  sending: boolean
  loading: boolean
}

const initialState = (): PasswordReset => {
  return {
    tokenError: false,
    sending: false,
    loading: false
  }
}

const usePasswordReset = defineStore('resetPassword', {
  state: () => initialState(),
  actions: {
    async checkPasswordToken(dto: Token) {
      this.loading = true

      return api
        .checkPasswordToken(dto)
        .then(() => {
          this.tokenError = false
        })
        .catch((error: ApiError) => {
          if (error.code === 400) {
            // token not valid
            this.tokenError = true
          } else {
            // other error
            handleApiError(error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async resetPassword(dto: PasswordResetDto) {
      return api
        .resetPassword(dto)
        .then(({ data }) => {
          helpers.reportSuccess(t('success.resetPassword', [data]))
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.resetPassword')
          })
        })
    },
    async changePassword(dto: ChangePasswordDto) {
      return api
        .changePassword(dto)
        .then(() => {
          this.tokenError = false
          helpers.reportSuccess(t('success.changePassword'))
          router.replace('/login')
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.changePassword')
          })
        })
    }
  }
})

export default usePasswordReset
